import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { EMPTY } from "rxjs";
import { tap } from "rxjs/operators";
import { patch, removeItem } from "@ngxs/store/operators";
import { BaseTestItemDto } from "src/app/models/dto/Base-Test-item-dto";
import { SoftwareVersionCoverageApiService } from "src/app/services/api/software-version-coverage-api.service";
import { SoftwareVersionCoverageActions } from "./softwareVersionCoverage.actions";
import { SoftwareVersionCoverageStateModel } from "./softwareVersionCoverage.state.model";

@State<SoftwareVersionCoverageStateModel>({
    name: 'softwareVersionCoverage',
    defaults: {
        softwareVersionCoverages: [],
        mySoftwareVersionCoverages: []
    },
})
@Injectable()
export class SoftwareVersionCoverageState {
    constructor(private softwareVersionCoverageApiService: SoftwareVersionCoverageApiService) {}

  @Action(SoftwareVersionCoverageActions.SetAllSoftwareVersionCoverages)
  SetAllSoftwareVersionCoverages(ctx: StateContext<SoftwareVersionCoverageStateModel>) {
    const state = ctx.getState();
    //don't update state if we have already downloaded items
    if (state.softwareVersionCoverages !== undefined && state.softwareVersionCoverages.length > 0) return EMPTY;

    return this.softwareVersionCoverageApiService.getAll('').pipe(
      tap((softwareVersionCoverages) => {
        ctx.patchState({ softwareVersionCoverages: softwareVersionCoverages });
      })
    );
  }

  @Action(SoftwareVersionCoverageActions.SetMySoftwareVersionCoverages)
  SetMySoftwareVersionCoverages(ctx: StateContext<SoftwareVersionCoverageStateModel>, action: SoftwareVersionCoverageActions.SetMySoftwareVersionCoverages) {
    const state = ctx.getState();
    //don't update state if we have already downloaded items
    if (state.mySoftwareVersionCoverages !== undefined && state.mySoftwareVersionCoverages.length > 0) return EMPTY;

    return this.softwareVersionCoverageApiService.getAll(action.userId).pipe(
      tap((softwareVersionCoverages) => {
        ctx.patchState({ mySoftwareVersionCoverages: softwareVersionCoverages });
      })
    );
  }

  @Action(SoftwareVersionCoverageActions.DeleteSoftwareVersionCoverage)
  DeleteSoftwareVersionCoverage(ctx: StateContext<SoftwareVersionCoverageStateModel>, action: SoftwareVersionCoverageActions.DeleteSoftwareVersionCoverage){
    return this.softwareVersionCoverageApiService.delete(action.softwareVersionCoverageUid).pipe(
      tap(result =>{
        ctx.setState(
          patch<SoftwareVersionCoverageStateModel>({
            softwareVersionCoverages: removeItem<BaseTestItemDto>(x => x.uid === action.softwareVersionCoverageUid),
            mySoftwareVersionCoverages: removeItem<BaseTestItemDto>(x => x.uid === action.softwareVersionCoverageUid)
          })
        )
      })
    );
  }
  
  @Action(SoftwareVersionCoverageActions.UpdateItem)
  updateItem(ctx: StateContext<SoftwareVersionCoverageStateModel>, action: SoftwareVersionCoverageActions.UpdateItem) {
    const state = ctx.getState();

    // Update in softwareVersionCoverages
    const allIdx = state.softwareVersionCoverages.findIndex(item => item.uid === action.item.uid);
    if (allIdx >= 0) {
      const updated = [...state.softwareVersionCoverages];
      updated[allIdx] = action.item;  // Full replace - action.item is already complete
      ctx.patchState({ softwareVersionCoverages: updated });
    }

    // Update in mySoftwareVersionCoverages
    const myIdx = state.mySoftwareVersionCoverages.findIndex(item => item.uid === action.item.uid);
    if (myIdx >= 0) {
      const updated = [...state.mySoftwareVersionCoverages];
      updated[myIdx] = action.item;  // Full replace - action.item is already complete
      ctx.patchState({ mySoftwareVersionCoverages: updated });
    }
  }

  @Action(SoftwareVersionCoverageActions.ClearCache)
  clearCache(ctx: StateContext<SoftwareVersionCoverageStateModel>) {
    ctx.patchState({
      softwareVersionCoverages: [],
      mySoftwareVersionCoverages: []
    });
  }

  @Selector()
  static getAllSoftwareVersionCoverages(state: SoftwareVersionCoverageStateModel) {
    return state.softwareVersionCoverages;
  }
  @Selector()
  static getMySoftwareVersionCoverages(state: SoftwareVersionCoverageStateModel) {
    return state.mySoftwareVersionCoverages;
  }
}